module.exports = __webpack_public_path__ + "img/Sherrill-Park.6c3c7da8.jpeg";